import { render, staticRenderFns } from "./IconSvgNextGen.vue?vue&type=template&id=6c3a2c92&scoped=true&"
import script from "./IconSvgNextGen.vue?vue&type=script&lang=js&"
export * from "./IconSvgNextGen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3a2c92",
  null
  
)

export default component.exports